/* eslint-disable */

import React from 'react'
import Helmet from 'react-helmet'


const CheckHelmet = () => (
  <Helmet>
    <title>Test helmet</title>
    <script id="testHelmetScript">var testHelmet = "test helmet";</script>
  </Helmet>
)


export default CheckHelmet
